'use strict';

require('string.prototype.matchall/auto');

require('globalthis/auto');

require('promise.allsettled/auto');
